import { Grid, Typography } from '@mui/material';
import EventCard from './EventCard/EventCard';
import React from 'react';

export const Section = ({
    title,
    titleVariant = 'h2',
    subtitle,
    events,
    handleEventSubClick,
    handleOverlapIconClick,
    otherEvents,
    futureEvent = false,
    liveNowEvent = false
}) => {
    return (
        <>
            <Typography variant={titleVariant}>{title}</Typography>
            {subtitle && <Typography variant='p'>{subtitle}</Typography>}
            <Grid container>
                {events.map((event) => {
                return (
                    <Grid item key={event.id}>
                        <EventCard
                          event={event}
                          handleEventSubClick={handleEventSubClick}
                          handleOverlapIconClick={handleOverlapIconClick}
                          otherEvents={otherEvents}
                          futureEvent={futureEvent} liveNowEvent={liveNowEvent}
                        />
                    </Grid>
                );
            })}
            </Grid>
        </>
    );
};
